import { lazy, Suspense, ComponentType } from 'react';
import { Route } from 'react-router-dom';

type RouteComponentEntry = {
  component: ComponentType<any>;
  name: string;
  route: string;
  ismenuitem: boolean;
};
import TaxesPaidProvider from '../../context/TaxesPaidContext';

// Lazy loading para las vistas
//const DefaultHomeView = lazy(() => Promise.resolve({ default: () => <div className='viewContainer'></div> }));
const DefaultHomeView = lazy(() => import('../../views/Home/HomeView'));
const ProfileDataFormView = lazy(() => import('../../views/Profile/Views/ProfileDataFormView'));
const InactiveUsersView = lazy(() => import('../../views/InactiveUsersView'));
const AskForLotsAndExpirationDateView = lazy(() => import('../../views/AskForLotsAndExpirationDateView'));
const OperationRoomStatisticsView = lazy(() => import('../../views/OperationRoomStatisticsView'));
const AddImagesToHC = lazy(() => import('../../views/AddImagesToHC'));
const TransferOrderView = lazy(() => import('../../views/TransferOrderView'));
const StretcherBearerView = lazy(() => import('../../views/StretcherBearerView'));
const TransfersStatisticsView = lazy(() => import('../../views/TransfersStatisticsView'));
const StretcherBearerRequestView = lazy(() => import('../../views/stretcherBearerRequestView'));
const HeatMapPatientTransferView = lazy(() => import('../../views/Heatmap/HeatMapPatientTransferView'));
const HonorariumView = lazy(() => import('../../views/Honorariums/HonorariumView'));
const HonorariumLiquidationView = lazy(() => import('../../views/HonorariumLiquidation/HonorariumLiquidationView'));
const HonorariumPreLiquidationView = lazy(() => import('../../views/HonorariumPreLiquidation/HonorariumPreLiquidationView'));
const Supplier = lazy(() => import('../../views/Supplier/Supplier'));
const HealthEntityView = lazy(() => import('../../views/HealthEntity/HealthEntity'));
const Accounting = lazy(() => import('../../views/Accounting/Accounting'));
const CloseMonth = lazy(() => import('../../views/CloseMonth'));
const EditOrderOfProvision = lazy(() => import('../../views/EditOrderOfProvision'));
const CrudTaxes = lazy(() => import('../../views/Tax/CrudTaxes'));
const AccountingMovementsView = lazy(() => import('../../views/AccountingMovementsView'));
const TSumOrIntegrationBalanceView = lazy(() => import('../../views/TSumOrIntegrationBalanceView'));
const VATPurchasesView = lazy(() => import('../../views/VATPurchasesView'));
const BankListView = lazy(() => import('../../views/Bank/BankListView'));
const BankAccountsView = lazy(() => import('../../views/Bank/BankAccountsView'));
const HomeHospitalizationReport = lazy(() => import('../../views/HomeHospitalization/HomeHospitalizationReport'));
const ValuationReportWithMedicationWindow = lazy(() => import('../../views/ValuationReportWithMedicationWindow'));
const ValorizedExistencesReportView = lazy(() => import('../../views/ValorizedExistencesReportView'));
const ReportGenerationSelection = lazy(() => import('../../views/Report/ReportGenerationSelection'));
const OperatorActionsReportView = lazy(() => import('../../views/OperatorActionsReportView'));
const CollapsiblePanel = lazy(() => import('../../views/CollapsiblePanel'));
const BudgetView = lazy(() => import('../../views/budget/BudgetView'));
const HospitalizationBillView = lazy(() => import('../../views/budget/HospitalizationBillView'));
const ManagerList = lazy(() => import('../../views/Manager/ManagerList'));
const Movements = lazy(() => import('../../views/Movements'));
const PaymentOrderView = lazy(() => import('../../views/PaymentOrder/PaymentOrderView'));
const OrderOfProvision = lazy(() => import('../../views/OrderOfProvision/OrderOfProvision'));
const RecipeView = lazy(() => import('../../views/Recipe/RecipeView'));
const LocationConfigView = lazy(() => import('../../views/Location/LocationConfigView'));
const DigitalRPQRView = lazy(() => import('../../views/Digitalrp/DigitalRPQRView'));
const FavoriteStudiesView = lazy(() => import('../../views/FavoriteStudies/FavoriteStudiesView'));
const StudyOrderView = lazy(() => import('../../views/StudyOrder/StudyOrderView'));
const StudyOrderHistoryView = lazy(() => import('../../views/StudyOrder/StudyOrderHistoryView'));
const MedicalSpecialitiesView = lazy(() => import('../../views/MedicalSpecialities/MedicalSpecialitiesView'));
const ServicesView = lazy(() => import('../../views/Services/ServicesView'));
const KitsView = lazy(() => import('../../views/Kits/KitsView'));
const StartingHourForDoseFrequencyView = lazy(() => import('../../views/StartingHourForDoseFrequency/StartingHourForDoseFrequencyView'));
const CalendarHolidayView = lazy(() => import('../../views/CalendarHoliday/CalendarHoliday'));
const UsersView = lazy(() => import('../../views/Users/UsersView'));
const CurrentAccountView = lazy(() => import('../../views/CurrentAccount/CurrentAccountView'));
const ProfessionalSettlementView = lazy(() => import('../../views/ProfessionalSettlement/ProfessionalSettlementView'));
const CashClosingReportView = lazy(() => import('../../views/CashClosingReport/CashClosingReportView'));
const SurgeryPartView = lazy(() => import('../../views/Surgery/SurgeryPartView'));
const LocationDeskView = lazy(() => import('../../views/LocationDesk/LocationDeskView'));
const FinancialAccountView = lazy(() => import('../../views/FinancialAccount/FinancialAccountView'));
const CashRegisterView = lazy(() => import('../../views/CashRegister/CashRegisterView'));
const CashRenditionView = lazy(() => import('../../views/CashRendition/CashRenditionView'));
const ContractsByItemTypeView = lazy(() => import('../../views/ContractsByItemType/ContractsByItemTypeView'));

// Route components
export const routeComponents: RouteComponentEntry[] = [
    { component: ProfileDataFormView, name: 'ProfileDataFormView', route: '/ProfileDataFormView', ismenuitem: false },
    { component: DefaultHomeView, name: 'homeView', route: '/home', ismenuitem: true },
    { component: InactiveUsersView, name: 'inactiveUsersView', route: '/inactiveusersview', ismenuitem: true },
    { component: AskForLotsAndExpirationDateView, name: 'askforlotsandexpirationdateview', route: '/askforlotsandexpirationdateview', ismenuitem: true },
    { component: OperationRoomStatisticsView, name: 'operationRoomStatisticsView', route: '/operationroomstatisticsview', ismenuitem: true },
    { component: AddImagesToHC, name: 'addimagestohc', route: '/addimagestohc', ismenuitem: true },
    { component: TransferOrderView, name: 'transferOrderView', route: '/transferorderview', ismenuitem: true },
    { component: StretcherBearerView, name: 'stretcherBearerView', route: '/stretcherbearerview', ismenuitem: true },
    { component: TransfersStatisticsView, name: 'transfersStatisticsView', route: '/transfersstatisticsview', ismenuitem: true },
    { component: StretcherBearerRequestView, name: 'stretcherbearerrequestview', route: '/stretcherbearerrequestview', ismenuitem: true },
    { component: HeatMapPatientTransferView, name: 'heatmappatienttransferview', route: '/heatmappatienttransferview', ismenuitem: true },
    { component: HonorariumView, name: 'honorariumView', route: '/honorariumview', ismenuitem: true },
    { component: HonorariumLiquidationView, name: 'honorariumLiquidationView', route: '/honorariumliquidationview', ismenuitem: true },
    { component: HonorariumPreLiquidationView, name: 'honorariumPreLiquidationView', route: '/honorariumprequidationview', ismenuitem: true },
    { component: ContractsByItemTypeView, name: 'contractsByItemTypeView', route: '/contractsbyitemtypeview', ismenuitem: true },
    { component: Supplier, name: 'supplierView', route: '/supplierview', ismenuitem: true },
    { component: HealthEntityView, name: 'CRUDEntitiesView', route: '/crudentitiesview', ismenuitem: true },
    { component: CalendarHolidayView, name: 'crudcalendarholidayview', route: '/crudcalendarholidayview', ismenuitem: true },
    { component: CalendarHolidayView, name: 'CRUDCalendarHolidayView', route: '/crudcalendarholidayview', ismenuitem: false },
    { component: Accounting, name: 'accountingView', route: '/accountingview', ismenuitem: true },
    { component: CloseMonth, name: 'closemonth', route: '/closemonth', ismenuitem: true },
    { component: EditOrderOfProvision, name: 'editorderofprovision', route: '/editorderofprovision', ismenuitem: true },
    { component: CrudTaxes, name: 'crudTaxesView', route: '/crudtaxesview', ismenuitem: true },
    { component: AccountingMovementsView, name: 'accountingMovementsView', route: '/accountingmovementsview', ismenuitem: true },
    { component: TSumOrIntegrationBalanceView, name: 'TSumOrIntegrationBalanceView', route: '/TSumOrIntegrationBalanceView', ismenuitem: true },
    { component: VATPurchasesView, name: 'VATPurchasesView', route: '/VATPurchasesView', ismenuitem: true },
    { component: BankListView, name: 'bankListView', route: '/banklistview', ismenuitem: true },
    { component: BankAccountsView, name: 'bankAccountsView', route: '/bankaccountsview', ismenuitem: true },
    { component: HomeHospitalizationReport, name: 'homeHospitalizationReportView', route: '/homehospitalizationreportview', ismenuitem: true },
    { component: ValuationReportWithMedicationWindow, name: 'valuationReportWithMedicationWindow', route: '/valuationReportWithMedicationWindow', ismenuitem: false },
    { component: ValorizedExistencesReportView, name: 'valorizedExistencesReportView', route: '/valorizedexistencesreportview', ismenuitem: true },
    { component: ReportGenerationSelection, name: 'reportGenerationSelection', route: '/reportGenerationSelection', ismenuitem: false },
    { component: OperatorActionsReportView, name: 'operatorActionsReportView', route: '/operatoractionsreportview', ismenuitem: true },
    { component: CollapsiblePanel, name: 'collapsiblepanel', route: '/collapsiblepanel', ismenuitem: false },
    { component: BudgetView, name: 'budgetView', route: '/budgetview', ismenuitem: true },
    { component: HospitalizationBillView, name: 'hospitalizationBillView', route: '/hospitalizationbillview', ismenuitem: true },
    { component: ManagerList, name: 'managerList', route: '/managerList', ismenuitem: true },
    { component: Movements, name: 'adminFormsExtView', route: '/adminformsextview', ismenuitem: true },
    { component: PaymentOrderView, name: 'paymentOrderView', route: '/paymentorderview', ismenuitem: true },
    { component: ()=>{
      return <TaxesPaidProvider>
        <OrderOfProvision/>
      </TaxesPaidProvider>
    }, name: 'orderOfProvision', route: '/orderofprovision', ismenuitem: true },
    { component: RecipeView, name: 'recipeView', route: '/recipeView', ismenuitem: false },
    { component: LocationConfigView, name: 'locationConfigView', route: '/locationconfigview', ismenuitem: true },
    { component: DigitalRPQRView, name: 'digitalrpqrview', route: '/digitalrpqrview', ismenuitem: true },
    { component: FavoriteStudiesView, name: 'favoriteStudiesView', route: '/favoritestudiesview', ismenuitem: true },
    { component: StudyOrderView, name: 'studyOrderView', route: '/studyorderview', ismenuitem: false },
    { component: StudyOrderHistoryView, name: 'studyOrderHistoryView', route: '/studyorderhistoryview', ismenuitem: false },
    { component: MedicalSpecialitiesView, name: 'CRUDMedicalSpecialtiesView', route: '/crudmedicalspecialtiesview', ismenuitem: true },
    { component: ServicesView, name: 'CRUDServiceView', route: '/crudserviceview', ismenuitem: true },
    { component: KitsView, name: 'CRUDStockItemsKitView', route: '/crudstockitemskitview', ismenuitem: true },
    { component: StartingHourForDoseFrequencyView, name: 'CRUDStartingHourForDoseFrequencyView', route: '/crudstartinghourfordosefrequencyview', ismenuitem: true },
    { component: UsersView, name: 'CRUDAdminView', route: '/crudadminview', ismenuitem: true },
    { component: CurrentAccountView, name: 'currentAccountView', route: '/currentaccountview', ismenuitem: true },
    { component: ProfessionalSettlementView, name: 'professionalSettlementView', route: '/professionalsettlementview', ismenuitem: true },
    { component: CashClosingReportView, name: 'cashClosingReportView', route: '/cashclosingreportview', ismenuitem: true },
    { component: SurgeryPartView, name: 'surgeryPartView', route: '/surgeryPartView', ismenuitem: false },
    { component: LocationDeskView, name: 'locationDeskView', route: '/locationdeskview', ismenuitem: true },
    { component: FinancialAccountView, name: 'financialAccountView', route: '/financialaccountview', ismenuitem: true },
    { component: CashRegisterView, name: 'cashRegisterView', route: '/cashregisterview', ismenuitem: true },
    { component: CashRenditionView, name: 'cashRenditionView', route: '/cashrenditionview', ismenuitem: true },
  ];

  export function LazyLoadingRoutes() {
    return (
      <Suspense fallback={<div>Loading...</div>}>
        {routeComponents.map(({ component: Component, route }, index) => (
          <Route key={index} path={route} element={<Component/>} />
        ))}
      </Suspense>
    );
  }

//// NOMENCLATORVIEW ////
export const healthEntityColor: any = {
  'OSDE': 'blue',
  'MEDICUS': 'green',
  'SWISS MEDICAL': 'red',
  'UP': 'yellow'
}

//// VALIDATOR ////
export const options = [
  { label: "DNI", value: 1 },
  { label: "Obra Social", value: 2 }
];

export const YesNoOptions = [
  { label: "Si", value: 1 },
  { label: "No", value: 2 }
];

